import {Card} from "react-bootstrap";

export const DashboardCardSkeleton = () => (
  <div style={{ display: 'flex', flexGrow: 4, margin: '.5rem', width: '25%' }}>
    <Card style={{ width: '100%' }} >
      <Card.Header className=" text-white">
        <div className="skeleton-box" style={{ height: '20px', width: '80%' }} />
      </Card.Header>
      <Card.Body className="text-left">
        <div className="skeleton-box" style={{ height: '60px', width: '60%' }} />
      </Card.Body>
    </Card>
  </div>
)
